/**
 * Admin app route matching by path features
 * @module routes/match-path
 */
import get from 'lodash/get'
import set from 'lodash/set'
import isFunction from 'lodash/isFunction'
import { match } from 'path-to-regexp'

/**
 * A cache for path to regex matchers
 */
const pathToRegexpMatcherCache = {}

/**
 * Match a pathname against a path pattern
 * @param {Object} options The params
 * @param {String} options.path The path pattern to check
 * @param {String} options.pathname The pathname value to check against path
 * @param {Boolean?} [options.disableCache] If true recompile the pathToRegexp matcher
 * @returns {Boolean} Returns an array if a match is found or null if not
 * @example A returned array with the whole path followed by the variables matched in order
 * // Arguments
 * const result = matchPath({ path: '/event/:eventId' pathname: '/event/test' })
 * // result
 * ['/event/test', 'test']
 */
export default function matchPath (options = {}) {
  const { path, pathname, disableCache } = options
  let matcher = get(pathToRegexpMatcherCache, path)
  if (!isFunction(matcher)) {
    matcher = match(path, [])
    if (!disableCache) {
      set(pathToRegexpMatcherCache, path, matcher)
    }
  }
  return matcher(pathname)
}
